// import React from 'react';

// const LoginSignupPage = () => {
//     return (
//         <div className="flex items-center justify-center min-h-screen bg-gray-50">
//             <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6">
//                 {/* Logo Section */}
//                 <div className="text-center mb-6">
//                     <h1 className="text-2xl font-bold text-gray-800">
//                         Moveon<span className="text-[#FF9630]">wheels</span>
//                     </h1>
//                     <p className="italic text-gray-600 text-sm">Rent. Get Go.</p>
//                 </div>

//                 {/* Image Section */}
//                 <div className="flex justify-center mb-4">
//                     <img
//                         src="https://via.placeholder.com/200" // Replace this with your image URL
//                         alt="Illustration"
//                         className="w-48"
//                     />
//                 </div>

//                 {/* Tagline */}
//                 <p className="text-center text-[#FF9630] font-semibold mb-6">
//                     Renting Dreams Since 2016
//                 </p>

//                 {/* Login/Signup Form */}
//                 <div>
//                     <h2 className="text-lg font-semibold text-gray-800 mb-2 text-center">
//                         Login or Signup
//                     </h2>
//                     <form>
//                         <div className="mb-4">
//                             <label
//                                 htmlFor="mobileNumber"
//                                 className="block text-sm font-medium text-gray-700"
//                             >
//                                 Enter Your Mobile Number
//                             </label>
//                             <input
//                                 type="text"
//                                 id="mobileNumber"
//                                 placeholder="+91 8884981840"
//                                 className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF9630] focus:border-transparent"
//                             />
//                         </div>
//                         <button
//                             type="submit"
//                             className="w-full bg-[#FF9630] hover:bg-orange-600 text-white py-2 rounded-lg font-medium"
//                         >
//                             Get OTP
//                         </button>
//                     </form>
//                 </div>

//                 {/* Footer */}
//                 <p className="text-center text-xs text-gray-500 mt-4">
//                     By clicking through, I agree with the{' '}
//                     <span className="text-[#FF9630] cursor-pointer">Terms of Service</span>{' '}
//                     &{' '}
//                     <span className="text-[#FF9630] cursor-pointer">Privacy Policy</span>.
//                 </p>
//             </div>
//         </div>
//     );
// };

// export default LoginSignupPage;


// import React from 'react';

// import logo from '../Components/assets/MOW_logo3.png';
// import logoImage from '../Components/assets/MSignin.png';

// const LoginSignupPage = () => {
//     return (
//         <div className="flex items-center justify-center bg-gray-50">
//             <div className=" w-full  rounded-lg p-6">
//                 {/* Logo Section */}
//                 <div className="flex justify-center mb-4">
//                     <img
//                         src={logo} // Using the imported image
//                         alt="logo"
//                         className="w-full max-w-xs "
//                     />
//                 </div>

//                 {/* Image Section */}
//                 <div className="flex justify-center mb-4">
//                     <img
//                         src={logoImage} // Using the imported image
//                         alt="Illustration"
//                         className="w-full max-w-xs h-60"
//                     />
//                 </div>

//                 {/* Tagline */}
//                 <p className="text-center text-[#FF9630] font-semibold mb-6">
//                     Renting Dreams Since 2016
//                 </p>

//                 {/* Login/Signup Form */}
//                 <div>
//                     <h2 className="text-lg font-semibold text-gray-800 mb-3 text-left">
//                         Login or Signup
//                     </h2>
//                     <form>
//                         <div className="mb-4">
//                             <label
//                                 htmlFor="mobileNumber"
//                                 className="block text-sm font-medium text-gray-700"
//                             >
//                                 Enter Your Mobile Number
//                             </label>
//                             <input
//                                 type="text"
//                                 id="mobileNumber"
//                                 placeholder="+91 8884981840"
//                                 className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF9630] focus:border-transparent"
//                             />
//                         </div>
//                         <button
//                             type="submit"
//                             className="w-full bg-[#FF9630] hover:bg-[#FF9630] text-white py-2 rounded-lg font-medium"
//                         >
//                             Get OTP
//                         </button>
//                     </form>
//                 </div>
//                 <p className="text-center text-xs text-gray-500 mt-10 space-y-1 ">
//                     <p>
//                         By clicking through, I agree with the{' '}
//                     </p>
//                     <p>
//                        <span className="text-[#FF9630] cursor-pointer"> Terms of Service <span className='text-gray-500'> & </span>Privacy Policy</span>.
//                     </p>
//                 </p>

//             </div>
//         </div>
//     );
// };

// export default LoginSignupPage;

import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/MOW_logo3.png';
import logoImage from '../../assets/MSignin.gif';

const LoginSignupPage = () => {
    const navigate = useNavigate(); // Initialize the useNavigate hook

    const handleSubmit = (e) => {
        e.preventDefault();
       
        navigate('/otp'); 
    };

    return (
        <div className="flex items-center justify-center bg-gray-50">
            <div className="w-full rounded-lg p-6">
                {/* Logo Section */}
                <div className="flex justify-center mb-4">
                    <img
                        src={logo}
                        alt="logo"
                        className="w-full max-w-xs"
                    />
                </div>

                {/* Image Section */}
                <div className="flex justify-center mb-4">
                    <img
                        src={logoImage}
                        alt="Illustration"
                        className="w-full max-w-xs h-60"
                    />
                </div>

                {/* Tagline */}
                <p className="text-center text-[#FF9630] font-semibold mb-6">
                    Renting Dreams Since 2016
                </p>

                {/* Login/Signup Form */}
                <div>
                    <h2 className="text-lg font-semibold text-gray-800 mb-3 text-left">
                        Login or Signup
                    </h2>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <label
                                htmlFor="mobileNumber"
                                className="block text-sm font-medium text-gray-700"
                            >
                                Enter Your Mobile Number
                            </label>
                            <input
                                type="text"
                                id="mobileNumber"
                                placeholder="+91 8884981840"
                                className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF9630] focus:border-transparent"
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-[#FF9630] hover:bg-[#FF9630] text-white py-2 rounded-lg font-medium"
                        >
                            Get OTP
                        </button>
                        <div>
                            <p className="text-center text-xs text-gray-500 mt-10 space-y-1 ">
                                <p>
                                    By clicking through, I agree with the{' '}
                                </p>
                                <p>
                                    <span className="text-[#FF9630] cursor-pointer"> Terms of Service <span className='text-gray-500'> & </span>Privacy Policy</span>.
                                </p>
                            </p>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    );
};

export default LoginSignupPage;
